import { Employee, IotAssetLink, ModelObject, NotificationDestination } from '@cco/model';

export interface Truck extends ModelObject<number> {
  uuid: string;
  iotAssetLink: IotAssetLink;
  name: string;
  notes: string;
  defaultDriverId: number;
  defaultDriver?: Employee;
  notificationDestinations: NotificationDestination[];
  manualMixDesignManagement: boolean;
  manuallyManagedMixDesignSlots: number[];
  clearOldAssignments: boolean;
  inactive?: boolean;
}

export const truckComparer = (a: Truck, b: Truck) => {

  const aIsInactive = !!a?.inactive;
  const bIsInactive = !!b?.inactive;

  if (aIsInactive && !bIsInactive) {
    return 1;
  } else if (!aIsInactive && bIsInactive) {
    return -1;
  }
  return compareNumberAndText(a, b);
};

export const compareNumberAndText = (a: Truck, b: Truck) => {
  const matchNumberInAName = a?.name?.match(/\d+/);
  const matchNumberInBName = b?.name?.match(/\d+/);

  const aHasNumber = matchNumberInAName != null;
  const bHasNumber = matchNumberInBName != null;

  if (aHasNumber && bHasNumber) {
    const numberInAName = +matchNumberInAName[0];
    const numberInBName = +matchNumberInBName[0];

    if (numberInAName === numberInBName) {
      return compareNameText(a, b);
    }
    return numberInAName < numberInBName ? -1 : 1;
  } else if (aHasNumber && !bHasNumber) {
    return -1;
  } else if (!aHasNumber && bHasNumber) {
    return 1;
  }
  return compareNameText(a, b);
};

export const compareNameText = (a: Truck, b: Truck) => {
  const aNameLength = a?.name?.length;
  const bNameLength = b?.name?.length;

  if (aNameLength === bNameLength) {
    return a.name.localeCompare(b.name);
  }
  return aNameLength < bNameLength ? -1 : 1;
};

